import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=32db0ad8"
import script from "./Notifications.ts?vue&type=script&lang=ts&external"
export * from "./Notifications.ts?vue&type=script&lang=ts&external"
import style0 from "./Notifications.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports